var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquareJointWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 42,
    viewBox: "0 0 86 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_432_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1405 9.96606L43 14.8755L56.8595 9.96606V30.6101L49.9298 24.5593L43 21.3559L36.0703 24.5593L29.1405 30.6101V9.96606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.8147e-06 2.84741L28.4297 2.84741V-4.55379e-05L-3.8147e-06 -4.55379e-05V2.84741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2727 42L31.2727 8.54236H29.1405L29.1405 42H31.2727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8595 42V8.54236H54.7273V42H56.8595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9427 0H57.5129V2.84746H85.9427V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5912 0.00012207C58.5912 5.92853 52.5773 14.3856 42.9548 14.3856C33.3325 14.3856 27.3185 5.92853 27.3185 0.00012207",
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3058 28.1187C53.3058 29.7844 52.3403 31.4404 50.4797 32.7393C48.6238 34.0348 45.9838 34.8814 43 34.8814C40.0162 34.8814 37.3761 34.0348 35.5203 32.7393C33.6597 31.4404 32.6942 29.7844 32.6942 28.1187C32.6942 26.453 33.6597 24.7969 35.5203 23.498C37.3761 22.2026 40.0162 21.356 43 21.356C45.9838 21.356 48.6238 22.2026 50.4797 23.498C52.3403 24.7969 53.3058 26.453 53.3058 28.1187Z",
    stroke: "white",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_432_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareJointWhite);
export default __webpack_public_path__ + "static/media/square-joint-white.89592d703756ff4ed35e232f31659ce8.svg";
export { ForwardRef as ReactComponent };